import { ReactElement } from 'react';
import styles from './PlaybackControls.module.scss';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '@customer/store/hooks';
import PlaybackTimestamp from '../playback-timestamp/PlaybackTimestamp';
import PlaybackButtons from '../playback-buttons/PlaybackButtons';
import PlaybackScrubber from '../playback-scrubber/PlaybackScrubber';
import { useGetRawTracks } from '@customer/store/apis/investigationsApi';
import Skeleton from 'react-loading-skeleton';

export const PlaybackControls = (): ReactElement => {
  const { investigationId } = useParams();
  const siteId = useAppSelector(state => state.auth.siteId);

  // Call the investigation and rawtracks queries in this component to make sure that the investigationsSlice is populated
  // with the essential state for the playback controls to work.
  const { investigation, rawTracks } = useGetRawTracks({
    siteId,
    investigationId,
  });

  const isLoaded =
    typeof siteId !== 'undefined' &&
    typeof investigationId !== 'undefined' &&
    Boolean(investigation) &&
    Boolean(rawTracks);

  return (
    <div className={styles.controls}>
      {isLoaded ? (
        <>
          <PlaybackButtons siteId={siteId} investigationId={investigationId} />
          <PlaybackTimestamp siteId={siteId} investigationId={investigationId} />
          <PlaybackScrubber siteId={siteId} investigationId={investigationId} />
        </>
      ) : (
        <>
          <Skeleton height={46} width={140} />
          <Skeleton height={22} width={120} />
          <Skeleton height={60} />
        </>
      )}
    </div>
  );
};

export default PlaybackControls;
